/*
 * File: LogoutHandler.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Handles logging out the user from the app

 */
import React from "react";
import LoginStore from "services/login/Store";

const LogoutHandler = ({ children }) => {
  let childProps = {
    onClick: () => {
      LoginStore.logout();
    }
  };

  return React.cloneElement(children, childProps);
};

export default LogoutHandler;
